import dokbotCustomSurvey from './dokbot-custom-survey';
export const dokbotMiddlewares = [dokbotCustomSurvey];
export default dokbotMiddlewares;
